import InventoryService from '../services/InventoryService';

export default class InventoryController {
  constructor({ repository, studentService, auditLogger }) {
    this.inventoryService = new InventoryService(repository, studentService, auditLogger);
    this.listeners = new Set();
  }

  subscribe(listener) {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  notify() {
    this.listeners.forEach((listener) => listener());
  }

  listItems() {
    return this.inventoryService.list();
  }

  getItem(id) {
    return this.inventoryService.getById(id);
  }

  createItem(data, user) {
    const item = this.inventoryService.create(data, user);
    this.notify();
    return item;
  }

  updateItem(id, data, user) {
    const item = this.inventoryService.update(id, data, user);
    this.notify();
    return item;
  }

  assignItem(id, assignment, user) {
    const item = this.inventoryService.assignItem(id, assignment, user);
    this.notify();
    return item;
  }

  checkInItem(id, assignmentId, user) {
    const item = this.inventoryService.checkInItem(id, assignmentId, user);
    this.notify();
    return item;
  }

  getDueStatus(item) {
    return this.inventoryService.getDueStatus(item);
  }

  getActiveAssignment(item) {
    return this.inventoryService.getActiveAssignment(item);
  }

  getAssignmentsForStudent(studentId) {
    return this.inventoryService.getAssignmentsForStudent(studentId);
  }

  getAssignmentsForStaff(staffId) {
    return this.inventoryService.getAssignmentsForStaff(staffId);
  }
}
